import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
}

export default function SEOMeta({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOMetaProps) {
  useEffect(() => {
    document.title = title;

    const metaTags: Record<string, string> = {
      'description': description,
      'og:title': title,
      'og:description': description,
      'og:type': ogType,
      'twitter:title': title,
      'twitter:description': description,
    };

    if (keywords) {
      metaTags['keywords'] = keywords;
    }

    if (canonicalUrl) {
      metaTags['og:url'] = canonicalUrl;
      const existingCanonical = document.querySelector('link[rel="canonical"]');
      if (existingCanonical) {
        existingCanonical.setAttribute('href', canonicalUrl);
      } else {
        const link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', canonicalUrl);
        document.head.appendChild(link);
      }
    }

    Object.entries(metaTags).forEach(([key, value]) => {
      const selector = key.startsWith('og:') || key.startsWith('twitter:')
        ? `meta[property="${key}"]`
        : `meta[name="${key}"]`;
      const el = document.querySelector(selector);
      if (el) {
        el.setAttribute('content', value);
      } else {
        const meta = document.createElement('meta');
        if (key.startsWith('og:') || key.startsWith('twitter:')) {
          meta.setAttribute('property', key);
        } else {
          meta.setAttribute('name', key);
        }
        meta.setAttribute('content', value);
        document.head.appendChild(meta);
      }
    });
  }, [title, description, keywords, canonicalUrl, ogType]);

  return null;
}